import { RouteNames } from './route-names';
import { simplePath } from './simple-path';
const project_cache = new Map();
function cache_me(path, param) {
    let { organization, project, query } = param;
    if (!(organization === null || organization === void 0 ? void 0 : organization.name) || !(project === null || project === void 0 ? void 0 : project.name)) {
        return '/';
    }
    const cache_key = "".concat(path, ":").concat(organization.name, ":").concat(project.name, ":").concat(query !== null && query !== void 0 ? query : '');
    if (project_cache.has(cache_key)) {
        var _project_cache_get;
        return (_project_cache_get = project_cache.get(cache_key)) !== null && _project_cache_get !== void 0 ? _project_cache_get : '/';
    }
    const params = {
        organization: organization.name,
        project: project.name
    };
    const url = simplePath(path, params) + (query !== null && query !== void 0 ? query : '');
    project_cache.set(cache_key, url);
    return url;
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project"
 *   params={{ organization: 'org-name', project: 'project-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function project_overview_path(props) {
    return cache_me(RouteNames.PROJECT_OVERVIEW, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/applications"
 *   params={{ organization: 'org-name', project: 'project-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function project_application_list_path(props) {
    return cache_me(RouteNames.PROJECT_APPLICATION_LIST, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/settings"
 *   params={{ organization: 'org-name', project: 'project-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function project_settings_general_path(props) {
    return cache_me(RouteNames.PROJECT_SETTINGS_GENERAL, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/settings/collaborators"
 *   params={{ organization: 'org-name', project: 'project-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function project_settings_collaborators_and_team_path(props) {
    return cache_me(RouteNames.PROJECT_SETTINGS_COLLABORATORS_AND_TEAM, props);
}
/**
 * @deprecated Use the path directly with Link and pass params
 * @example
 *   <Link
 *   to="/org/$organization/$project/settings/deployment-integrations"
 *   params={{ organization: 'org-name', project: 'project-name' }}
 *   >
 *   Link text
 *   </Link>
 */ export function project_settings_deployment_integrations_path(props) {
    return cache_me(RouteNames.PROJECT_SETTINGS_DEPLOYMENT_INTEGRATION_LIST, props);
}
/** @deprecated Use the path directly with Link and pass params */ export function project_settings_audit_log_path(props) {
    return cache_me(RouteNames.PROJECT_SETTINGS_AUDIT_LOG, props);
}
